/**
 *
 *  CalendarDayContents
 *  TruBe Date Time CalendarDayContents Component
 *
 *  Created by Vladimir Shishlyannikov on 28/02/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";

import { getModifierSettings } from "../helpers/getModifierSettings";

import { availabilityCalendar as calendarConstants } from "../../../constants";

export default function CalendarDayContents({
  day,
  dayFormat = "D",
  weekDayFormat = "dddd",
  daySize = calendarConstants.DEFAULT_CALENDAR_DAY_SIZE,
  direction,
  modifiers,
  special,
  // onDayMouseEnter,
  // onDayMouseLeave,
}) {
  const [highlighted, setHighlighted] = useState(false);

  const { selected } = getModifierSettings(modifiers);

  const handleMouseEnter = useCallback(() => {
    setHighlighted(true);
  }, []);

  const handleMouseOut = useCallback(() => {
    setHighlighted(false);
  }, []);

  const childrenElements = (
    <React.Fragment>
      <div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseOut}
        className={`calendar-day-contents tbk-relative tbk-flex tbk-h-6 tbk-w-[77px] tbk-flex-col tbk-items-center tbk-justify-center tbk-rounded-lg md:tbk-w-[76px] ${
          selected
            ? "tbk-bg-coral"
            : "tbk-border tbk-border-solid tbk-border-transparent tbk-bg-basic-white hover:tbk-border-blue-grey-light"
        }`}
      >
        <div
          className={`calendar-day-caption tbk-text-small ${
            selected ? "tbk-text-basic-white" : "tbk-text-primary"
          }`}
        >
          {day.format(weekDayFormat)}
        </div>
        <div
          className={`tbk-text-title-medium ${
            selected
              ? "tbk-text-basic-white"
              : highlighted
              ? "tbk-text-coral"
              : "tbk-text-primary"
          }`}
        >
          {day.format(dayFormat)}
        </div>
      </div>
    </React.Fragment>
  );

  return <>{childrenElements}</>;
}

CalendarDayContents.propTypes = {
  day: PropTypes.instanceOf(moment),
  dayFormat: PropTypes.string,
  modifiers: PropTypes.object,
};
